import { isSuperAdminSession } from "utils/accessibleRoutes"

/** Platform operators (not impersonating a tenant) manage country CRUD. */
export const isPlatformCountryManager = ({ accountType, accountScope } = {}) => {
  const tenantId =
    typeof localStorage !== "undefined"
      ? localStorage.getItem("tenantId")
      : null
  return isSuperAdminSession({ accountType, accountScope }) && !tenantId
}
